import { render, staticRenderFns } from "./DataMappingTour.vue?vue&type=template&id=2b7c0621&"
import script from "./DataMappingTour.vue?vue&type=script&lang=js&"
export * from "./DataMappingTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports